import { Component, Inject, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mdl-task',
  imports: [FormsModule, CommonModule],
  templateUrl: './mdl-add-product.html',
  styleUrl: './mdl-add-product.css',
})
export class Mdladdproduct implements OnInit {
  private api = inject(Api);
  public productos: any = [];
  public filteredProducts: any = [];
  public searchTerm: string = '';
  selectedProducts: any[] = [];
  allProducts: any[] = [];
  presupuestoId!: string;
  sendEmail: boolean = false;
  internal_loading: boolean = false;

  constructor(
    public mdl: MatDialogRef<Mdladdproduct>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.presupuestoId = data?.presupuestoId;
    console.log('🧾 Presupuesto ID recibido:', this.presupuestoId);

    if (data?.productos) {
      this.allProducts = data.productos;
    }
  }

  ngOnInit(): void {
    this.getProducts();
  }

  getProducts() {
    this.internal_loading = true;
    this.api.getProductsFromManager().subscribe({
      next: (data: any) => {
        this.productos = data.productos;
        this.filteredProducts = [...this.productos]; // Inicializar productos filtrados
        this.internal_loading = false;
      },
      error: (error) => {
        this.internal_loading = false;
        console.error('Error fetching products:', error);
      },
    });
  }

  toggleSelection(product: any) {
    const index = this.selectedProducts.findIndex(
      (p) => p.codigo_prod === product.codigo_prod
    );
    if (index > -1) {
      this.selectedProducts.splice(index, 1);
    } else {
      this.selectedProducts.push({ ...product, cantidad: 1 });
    }
    console.log('Seleccionados:', this.selectedProducts);
  }

  isSelected(product: any): boolean {
    return this.selectedProducts.some(
      (p) => p.codigo_prod === product.codigo_prod
    );
  }

  closeMdl() {
    this.mdl.close();
  }

  saveProducts() {
    if (!this.selectedProducts.length) {
      alert('Selecciona al menos un producto');
      return;
    }

    const payload = {
      presupuesto_id: this.presupuestoId,
      productos: this.selectedProducts.map((p) => ({
        producto_servicio: p.nombre,
        cantidad: p.cantidad || 1,
        precio_unitario: Number(p.precio_lista) || 0,
        iva_aplicable: true,
      })),

      cambio_descripcion: 'Se agregaron productos desde el manager',
    };
    console.log('📦 Payload enviado:', payload);

    this.api.addProductsBudget(payload).subscribe({
      next: (res) => {
        console.log('✅ Productos guardados', res);
        this.mdl.close(res);
      },
      error: (err) => {
        console.error(' Error guardando productos:', err);
      },
    });
  }

  // Método para filtrar productos
  filterProducts() {
    if (!this.searchTerm.trim()) {
      this.filteredProducts = [...this.productos];
      return;
    }

    const term = this.searchTerm.toLowerCase().trim();
    this.filteredProducts = this.productos.filter((product: any) => {
      const nombre = product.nombre?.toLowerCase() || '';
      const descripcion = product.descripcion?.toLowerCase() || '';
      const partnum = product.partnum?.toLowerCase() || '';
      
      return nombre.includes(term) || 
             descripcion.includes(term) || 
             partnum.includes(term);
    });
  }

  // Método que se ejecuta cuando cambia el término de búsqueda
  onSearchChange() {
    this.filterProducts();
  }
}
